; "use strict";

import State from './state';
//import MainData from './maindata';
//import CustUK from './custuk';
import CustKD from './custkd';

//let MainData, CustUK;

class Calc {

	constructor() {

		this.mainDataBuf = [];
		this.custDataBuf = [];
		this.getRegData();
	}


/////////////////////////////

	resetData() {

	}

/////////////////////////////
// Заполняем для текущего региона буфера стоимости для всех КСГ

	fillKsgBuf() {

		var cnt, len, regData, code;

		regData = State.MainData[State.currRegNum];
		len = State.dsList.length;
		for(cnt=0 ; cnt<len ; cnt++) {
			code = State.dsList[cnt];
			State.dsBuf[code] = this.calcIncome(regData, State.dsList[cnt]);
		}
		len = State.stList.length;
		for(cnt=0 ; cnt<len ; cnt++) {
			code = State.stList[cnt];
			State.stBuf[code] = this.calcIncome(regData, State.stList[cnt]);
		}

	}


/////////////////////////////
// Расчитываем стоимость случая для одного КСГ


	calcIncome(regdata, code) {

		let kz, dzp, res, bs, kus, uk, kd, customUK = -1, customKD = -1, index;

		if(code=='') return 0;
		if(code==undefined) return 0;
		kz = this.getKsgValue(code);
		dzp = this.getDzpValue(code);
		index = regdata.id;
		if(State.CustUK[index]) if(State.CustUK[index][code]) customUK = State.CustUK[index][code];
		if(CustKD[index]) if(CustKD[index][code]) customKD = CustKD[index][code];
		if(-1 != code.indexOf('ds')) {
			bs = regdata.bs_ds;
			kus = regdata.kus_ds;
			uk = regdata.uk_ds;
			kd = regdata.kd_ds
		}
		else if(-1 != code.indexOf('st')) {
			bs = regdata.bs_ks;
			kus = regdata.kus_ks;
			uk = regdata.uk_ks;
			kd = regdata.kd_ks
		}
		else return 0;

// СС = БС*КЗ*((1-ДЗП)+ДЗП*ПК*КД*КС)
//		res = bs*kz*((1.0 - dzp) + dzp*kus*kd);

		if(customUK==-1) res = bs*kz*((1.0 - dzp) + dzp*kus*kd);
		else {
			res = bs*kz*((1.0 - dzp) + dzp*kus*kd*customUK);
		}

		// if(customUK==-1) res = bs*kz*kus*uk;
		// else res = bs*kz*kus*customUK;
		
		// if(customKD==-1) res *= kd;
		// else res *= customKD;
//		res = Math.round(res);
		return res;
	}


///////////////////////////////////

	getKsgValue(ksg) {

		const ksgData = {
			'ds23.001': 0.9,
			'ds35.001': 1.08,
			'ds35.002': 1.41,
			'ds36.006': 0.4,
			'ds36.008': 1.29,
			'ds36.009': 3.23,
			'ds36.010': 8.93,

			'st12.015': 2.87,
			'st12.016': 4.96,
			'st12.017': 7.4,
			'st12.018': 12.07,
			'st12.019': 2.07,
			'st23.005': 2.11,
			'st27.011': 0.89,
			'st35.001': 1.02,
			'st35.002': 1.49,
			'st36.012': 0.5,
			'st36.017': 1.04,
			'st36.018': 2.14,
			'st36.019': 6.31
		}

		if(ksgData[ksg]) return ksgData[ksg];
		else return 0;
	}

///////////////////////////////////

	getDzpValue(ksg) {

		const dzpData = {
			'ds23.001': 100,
			'ds35.001': 100,
			'ds35.002': 100,
			'ds36.006': 100,
			'ds36.008': 5.85,
			'ds36.009': 5.43,
			'ds36.010': 8.94,

			'st12.015': 93.88,
			'st12.016': 66.53,
			'st12.017': 68.28,
			'st12.018': 77.63,
			'st12.019': 100,
			'st23.005': 100,
			'st27.011': 100,
			'st35.001': 100,
			'st35.002': 100,
			'st36.012': 100,
			'st36.017': 32.68,
			'st36.018': 18.82,
			'st36.019': 6.00
		}

		if(dzpData[ksg]) return dzpData[ksg]/100.0;
		else return 0;
	}

///////////////////////////////////
// Проверяем, нет ли сохраненных данных по распределению пациентов в LS

	checkDataSaved() {

		const key = 'mn_meth';

		let dataSet = localStorage.getItem(key);
		return (null != dataSet)
	}

///////////////////////////////////

	getUserData(e){

		let deploy, apiUrl, n;

		deploy = this.getAppLocation();
	    
	    if(deploy == 'production') apiUrl = './userdata/api/user/';
	    if(deploy == 'testing') apiUrl = './userdata/api/user/';
	    if(deploy == 'local') apiUrl = '../userdata/api/user/';

		if(e.charCode==13 || e.target.id=='login-butt') {

			n = $('#login-input').val();
	    	$.ajax({
	           url: apiUrl+n,
	           type: "get",
	           async: true,
	           data: {},
	           dataType: "json",
	           contentType: "application/json",
	           success: (data)=>{ 
              		State.authToken = data.nonpass;
              		checkLogin();
	              },
	           error: function(data){ 
	           		console.log('No connection to user DB');
	           		console.log(data); 
	           		this.netError = 1;
	           	}
	        });             
		}
	}

///////////////////////////////////

	getAppLocation() {

		let addr, deploy;

		addr = window.location.href;
		if(addr.indexOf('ksgcalc.ru')!=-1) deploy = 'local'; 
		if(addr.indexOf('critical.ru')!=-1) deploy = 'testing'; 
		if(addr.indexOf('calculatoroms.ru')!=-1) deploy = 'production'; 

		return deploy;
	}

///////////////////////////////////

	getRegData(){

	    var apiUrl = '../data/api/',
	    	regionUrl, customUkUrl, addr, res, deploy,
	    	regsBufer = {},
	    	ukBufer = {};

		deploy = this.getAppLocation();
	    
	    if(deploy == 'production') apiUrl = './noncodata/api/';
	    if(deploy == 'testing') apiUrl = './noncodata/api/';
	    if(deploy == 'local') apiUrl = '../noncodata/api/';

	    regionUrl = apiUrl + 'datanononcos';
	    customUkUrl = apiUrl + 'ukcustnononcos';
	    State.flDataLoad = 0;
	    $.ajax({
	           url: regionUrl,
	           type: "get",
	           async: true,
	           data: {},
	           dataType: "json",
	           contentType: "application/json",
	           success: (data)=>{ 
	           	  State.flDataLoad++	
	              this.mainDataBuf = data.rows;
	              if(State.flDataLoad>1) {
		            	this.loadMainData();
		            	this.loadCustData();
	              		State.hideLoadBanner();
	              	}
	              },
	           error: function(data){ 
	           		console.log('No connection to region DB');
	           		console.log(data); 
	           		this.netError = 1;
	           	}
	          });             

	    $.ajax({
	           url: customUkUrl,
	           type: "get",
	           async: true,
	           data: {},
	           dataType: "json",
	           contentType: "application/json",
	           success: (data)=>{ 
	           	  State.flDataLoad++	
	              this.custDataBuf = data.rows;
	              if(State.flDataLoad>1) {
	                	this.loadMainData();
		            	this.loadCustData();
	              		State.hideLoadBanner();
	              	}
	              },
	           error: function(data){ 
	           		console.log('No connection to customUK DB');
	           		console.log(data);  this.netError = 1;
	           	}
	          });
	}       

/////////////////////////////

	loadMainData() {

		let input = this.mainDataBuf;
		let len = input.length, i, inp, out;

		State.MainData = [];
		for(i=0 ; i<len ; i++) {
			out = {};
			inp = input[i];
			out.id = inp.id;
			out.sub = inp.subjnum;
			out.name = inp.name;
			out.bs_ds = inp.bnDs;
			out.bs_ks = inp.bnKs;
			out.kus_ds = inp.kusDs;
			out.kus_ks = inp.kusKs;
			out.uk_ds = inp.ukDs;
			out.uk_ks = inp.ukKs;
			out.kd_ds = inp.kdDs;
			out.kd_ks = inp.kdKs;
			State.MainData.push(out);			
		}
//console.log(State.MainData);
	}

/////////////////////////////

	loadCustData() {

		let input = this.custDataBuf;
		let len = input.length, i, inp, out, custData, regId, ksgSet;
		
		State.CustUK = {};
		for(i=0 ; i<len ; i++) {
			custData = input[i];
			regId = custData.id;
			ksgSet = {};
			ksgSet['ds23.001'] = custData.ds23001;
			ksgSet['ds35.001'] = custData.ds35001;
			ksgSet['ds35.002'] = custData.ds35002;
			ksgSet['ds36.006'] = custData.ds36006;
			ksgSet['ds36.008'] = custData.ds36008;
			ksgSet['ds36.009'] = custData.ds36009;
			ksgSet['ds36.010'] = custData.ds36010;
			ksgSet['st12.015'] = custData.st12015;
			ksgSet['st12.016'] = custData.st12016;
			ksgSet['st12.017'] = custData.st12017;
			ksgSet['st12.018'] = custData.st12018;
			ksgSet['st12.019'] = custData.st12019;
			ksgSet['st23.005'] = custData.st23005;
			ksgSet['st27.011'] = custData.st27011;
			ksgSet['st35.001'] = custData.st35001;
			ksgSet['st35.002'] = custData.st35002;
			ksgSet['st36.012'] = custData.st36012;
			ksgSet['st36.017'] = custData.st36017;
			ksgSet['st36.018'] = custData.st36018;
			ksgSet['st36.019'] = custData.st36019;
			State.CustUK[regId] = ksgSet;
		}
	State.regSelector.initRegData();
	
	}

/////////////////////////////

	restoreAllData() {

	}

/////////////////////////////


	initDataSet() {

	}


/////////////////////////////

    padDigits(str){

        var res='',s='',i,cnt,n;

        str = '' + str;
        n = str.length;

        for(i=0,cnt=0;i<n;i++){
            s = s + str.slice(-1);
            str = str.slice(0,str.length-1);
            cnt++;
            if(cnt>=3){
                cnt = 0;
                s = s + ' ';
            }
        }
        n = s.length;
        for(i=0;i<n;i++){
            res = res + s.slice(-1);
            s = s.slice(0,s.length-1);
        }
	    return(res);
    }

/////////////////////////////

    padFloat(str){

        var res='',s='',i,cnt,n, ext, point;

        ext = '';
        str = '' + str;
        point = str.indexOf('.');
        if(point==-1) { str = str + '.00'};
        point = str.indexOf('.');
        if(point>-1) {
            ext = str.slice(point+1, str.length);
            str = str.slice(0, point);
            if(ext.length > 2) ext = ext.slice(0, 1);
            if(ext.length == 1) ext = ext + '0';
            if(ext.length == 0) ext = ext + '00';
        }
        n = str.length;
        for(i=0,cnt=0;i<n;i++){
            s = s + str.slice(-1);
            str = str.slice(0,str.length-1);
            cnt++;
            if(cnt>=3){
                cnt = 0;
                s = s + ' ';
            }
        }
        n = s.length;
        for(i=0;i<n;i++){
            res = res + s.slice(-1);
            s = s.slice(0,s.length-1);
        }
        if(ext!='') {
            res += ',';
            res += ext;
        }
    return(res);

    }

}

export default Calc;